import { render, staticRenderFns } from "./PagePrincipalIndicePreco.vue?vue&type=template&id=02e0a7da&scoped=true"
import script from "./PagePrincipalIndicePreco.vue?vue&type=script&lang=js"
export * from "./PagePrincipalIndicePreco.vue?vue&type=script&lang=js"
import style0 from "./PagePrincipalIndicePreco.vue?vue&type=style&index=0&id=02e0a7da&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e0a7da",
  null
  
)

export default component.exports